export const setTileAmountPrefix = (label) => {
  if (["totalSpend", "averageRate"].includes(label)) {
    return "$";
  }
  return "";
};
